<template>
  <ElForm :model="formModel" class="modal-form">
    <ElFormItem size="mini" prop="matchingType">
      <ListSelect
        v-model="formModel.matchingType"
        :items="matchingTypeValueLabel"
      />
    </ElFormItem>
    <ElFormItem class="modal-form__actions">
      <ElButton size="mini" type="text" @click="save">
        {{ $t('SAVE') }}
      </ElButton>
      <ElButton size="mini" type="text" @click="close">
        {{ $t('CANCEL') }}
      </ElButton>
    </ElFormItem>
  </ElForm>
</template>

<script>
import ListSelect from '@@/advertisement/common/ListSelect';

import form from '@/mixins/form';
import campaignId from '@/mixins/advertisement/campaignId';

import { matchingTypes } from '@@/advertisement/common/constants';

export default {
  name: 'MatchTypeColumnContentForm',
  components: {
    ListSelect,
  },
  mixins: [form, campaignId],
  props: {
    initialMatchingType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formModel: {
        matchingType: this.initialMatchingType,
      },
    };
  },
  computed: {
    matchingTypeValueLabel() {
      return matchingTypes.map(({ property, label }) => ({
        value: property,
        label: label,
      }));
    },
  },
  methods: {
    save() {
      this.$emit('save', this.formModel.matchingType);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
